import { render } from "./ItemPropuesta.vue?vue&type=template&id=0fcbc13a&scoped=true"
import script from "./ItemPropuesta.vue?vue&type=script&lang=js"
export * from "./ItemPropuesta.vue?vue&type=script&lang=js"

import "./ItemPropuesta.vue?vue&type=style&index=0&id=0fcbc13a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fcbc13a"

export default script